var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category-page',{attrs:{"resource-params":_vm.resourceParams,"available-filters":_vm.availableFilters,"parent":_vm.parent}})
}
var staticRenderFns = []

export { render, staticRenderFns }